import moment from "moment";
import VuetableFieldCheckbox from "vuetable-2/src/components/VuetableFieldCheckbox.vue";
import numeral from 'numeral'
import i18n from '@/plugins/i18n';
import { convertTimezone } from "@/common/tenancy/convertTimezone";

export default [
    {
        name: "index",
        title: '<i class="fa-solid fa-bars"></i>',
        sortField: "index",
        width:'400px',
        filterable: false,
        togglable: false
    },
    {
        name: "name",
        title: i18n.t('Sale Contact Name'),
        sortField: "name",
        width:'400px',
        filterable: false,
        togglable: false
    },
    {
        name: "slug",
        title: i18n.t('Default'),
        sortField: "slug",
        width:'400px',
        filterable: false,
        togglable: false
    },
    {
        name: "attribute_options",
        title: i18n.t('Status'),
        sortField: "attribute_options",
        width:'400px',
        filterable: false,
        togglable: false
    },
    {
        name: "created_date",
        sortField: 'created_date',
        title: i18n.t('Create Date'),
        width: "200px",
        togglable: true,
        formatter: (value) => {
            return (value === null) ?
                '' :
                convertTimezone.utcToLocal(value)
        }
    },
    {
        name: "actions",
        title: i18n.t("Actions"),
        width: "180px",

    }

];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/settings/sale/sale-contact/assets/template/vuetable/FieldsDef.js